// extracted by mini-css-extract-plugin
export default {"loading":"_1IKs","error":"GSJC","result":"_3OWW","internalPanelSize":"_1YiD","description":"_3m0j"};